export const sidebarActiveNavLinks = [
	{
		name: 'Brands',
		link: '/admin/brands',
	},
	{
		name: 'PRO Invites',
		link: '/admin/invite-access',
	},
];

export const excludedCategoryIds = [
	'6519604594c1b61a4d62db72',
	'6519604594c1b61a4d62db74',
	'6519604594c1b61a4d62db6a',
	'6519604594c1b61a4d62db70',
];
